import { View, Text } from 'react-native';

function ClassifiedRemoveSuccess() {
    const renderRemoved = () => {
        const queryString = require('query-string');
        const parsed = queryString.parse(window.location.search);
        console.log(parsed);
        console.log('parsed');
        console.log(parsed.email);
        console.log(parsed.title);

        let isParsed = parsed && parsed.email && parsed.title;

        if(isParsed){
            return (
                <View style={{flex: 1, justifyContent: "center", alignItems: "center", marginLeft: 10}}>
                   <Text>Your classified ad titled {parsed.title} has been removed</Text>
                   <Text>The ad originally was created by the {parsed.email} email</Text>
                </View>
            );
        }

        return (
            <View style={{flex: 1, justifyContent: "center", alignItems: "center", marginLeft: 10}}>
               <Text style={{textAlign: 'center', color: 'red'}}>We are having trouble processing your request</Text>
               <Text>Please try again later</Text>
            </View>
        );
    }


    // main render
    return (
        <div>
            {renderRemoved()}
        </div>
    );
}

export default ClassifiedRemoveSuccess;